// Shared loading skeletons — unified "warme Kacheln" placeholders used across
// the Web App so every screen has a consistent loading state (UX Rework 3.0 §4).
import { Skeleton } from "@/components/ui/skeleton";

export function ListSkeleton({ rows = 4, className = "" }) {
  return (
    <div className={`space-y-3 ${className}`} data-testid="list-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4">
          <Skeleton className="h-10 w-10 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function StatGridSkeleton({ count = 4, className = "" }) {
  return (
    <div className={`grid grid-cols-2 gap-3 sm:grid-cols-4 ${className}`} data-testid="stat-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-border bg-card p-5">
          <Skeleton className="h-8 w-12" />
          <Skeleton className="mt-2 h-3 w-20" />
        </div>
      ))}
    </div>
  );
}

export function CardGridSkeleton({ count = 3, className = "", cardClassName = "h-40" }) {
  return (
    <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3 ${className}`} data-testid="card-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className={`${cardClassName} rounded-3xl`} />
      ))}
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="space-y-6" data-testid="page-skeleton">
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-4 w-80" />
      </div>
      <CardGridSkeleton />
      <ListSkeleton rows={3} />
    </div>
  );
}
